export default __webpack_public_path__ + "static/media/nest-logo.96caa26b.png";